import React, { useEffect, useState } from 'react';
import { getPhotoDisplayUrl } from '../../utils/photoUtilities';
import './LazyPhoto.css';

/**
 * Photo with a soft placeholder until the S3 image finishes loading.
 */
export default function LazyPhoto({
  photo,
  alt = 'Asset photo',
  className = '',
  style,
  imageStyle,
  objectFit = 'contain',
  onClick,
}) {
  const src = getPhotoDisplayUrl(photo);
  const isPlaceholder = !src || src === '/placeholder.svg';
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
  }, [src]);

  const shimmer = !loaded && !failed && !isPlaceholder ? ' lazy-photo--loading' : '';

  return (
    <div
      className={`lazy-photo${shimmer}${className ? ` ${className}` : ''}`}
      onClick={onClick}
      style={style}
    >
      {!isPlaceholder && !failed ? (
        <img
          src={src}
          alt={alt}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          className={`lazy-photo__img${loaded ? ' lazy-photo__img--loaded' : ''}`}
          style={{
            objectFit,
            ...imageStyle,
          }}
        />
      ) : (
        <span className="lazy-photo__empty">{failed ? 'Unavailable' : 'No photo'}</span>
      )}
    </div>
  );
}
